'use strict';

angular.module('app').directive('formPopup', function ($compile, $rootScope, $location, $timeout, $http) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      $(element).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        function scrollTo() {
          $timeout(function () {
            var $parentDiv = $('.fancybox-inner');

            $parentDiv.scrollTop($parentDiv.scrollTop() + $(attrs.scrollTo).position().top);
          }, 350);
        }

        function openFancybox(url) {
          $http.get(url + '?v=2').then(function (response) {
            if (response.status === 200) {
              var template = $compile(angular.element(response.data))(scope);

              $.fancybox({
                content: template,
                openEffect: 'elastic',
                type: 'html',
                padding: attrs.padding ? (attrs.padding).split(',') : 40,
                wrapCSS: (attrs.formClass) ? 'form-popup ' + attrs.formClass : 'form-popup',
                maxWidth: attrs.maxWidth,
                beforeShow: function () {
                  if (attrs.beforeShow) {
                    if (attrs.useScope) {
                      if (_.isFunction($rootScope[attrs.beforeShow])) {
                        $rootScope[attrs.beforeShow]();
                      }
                    } else if (_.isFunction(scope[attrs.beforeShow])) {
                      scope[attrs.beforeShow]();
                    }
                  }
                },
                afterClose: function () {
                  scope.step = 1;

                  if (attrs.onClose) {
                    if (attrs.useScope) {
                      if (_.isFunction($rootScope[attrs.onClose])) {
                        $rootScope[attrs.onClose]();
                      }
                    } else if (_.isFunction(scope[attrs.onClose])) {
                      scope[attrs.onClose]();
                    }
                  }
                },
                afterShow: function () {
                  if (attrs.callback && _.isFunction(scope[attrs.callback])) {
                    scope[attrs.callback]();
                  }

                  if (attrs.scrollTo) {
                    if (attrs.scrollToCallback) {
                      scope.$watch(function () {
                        return scope.$eval(attrs.scrollToCallback);
                      },
                      function (newVal) {
                        if (newVal === false) {
                          scrollTo();
                        }
                      }
                      );
                    } else {
                      scrollTo();
                    }
                  }

                  if ($location.search().showRatingPopup) {
                    scope.$apply(function () {
                      $location.search('');
                    });
                  }

                  $timeout(function () {
                    $.fancybox.update();
                  }, 300);
                },
                helpers: {
                  overlay: {
                    locked: true,
                  },
                },
              });
            }
          });
        }

        if (attrs.screenSize) {
          if (attrs.screenSize >= window.innerWidth) {
            return openFancybox(attrs.includeHtml);
          }

          return true;
        }

        openFancybox(attrs.includeHtml);
      });

      scope.$watch('step', function (newVal) {
        if (newVal == 3) {
          if ($(document).find('.add-review')) {
            $(document).find('.add-review').addClass('step3');
          }
        } else {
          $(document).find('.add-review').removeClass('step3');
        }
        jQuery.fancybox.update();
      });

      $(document).on('click', '.popup-close', function () {
        jQuery.fancybox.close(true);
      });
    },
  };
});
